export const rankingItems = [
  {
    rank: 1,
    title: '某顶流疑似恋情曝光，工作室连夜发声明回应引热议',
    heat: '986万',
    category: '娱乐八卦',
    trend: 'up',
    tag: '爆',
  },
  {
    rank: 2,
    title: '热播剧大结局编剧被骂上热搜，观众直呼意难平',
    heat: '872万',
    category: '影视综艺',
    trend: 'up',
    tag: '热',
  },
  {
    rank: 3,
    title: '知名歌手演唱会突发状况，现场观众拍下全程视频',
    heat: '765万',
    category: '音乐现场',
    trend: 'up',
    tag: '新',
  },
  {
    rank: 4,
    title: '某综艺节目录制现场嘉宾互撕，节目组紧急公关',
    heat: '698万',
    category: '综艺吃瓜',
    trend: 'down',
    tag: '',
  },
  {
    rank: 5,
    title: '网红直播间带货翻车名场面，网友剪辑全网疯传',
    heat: '621万',
    category: '网红动态',
    trend: 'up',
    tag: '',
  },
  {
    rank: 6,
    title: '某品牌代言人突然解约，背后原因引发多方猜测',
    heat: '554万',
    category: '品牌八卦',
    trend: 'up',
    tag: '热',
  },
];

export const featuresList = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时不间断追踪，最新吃瓜资讯第一时间推送到你面前，绝不让你错过任何一个热点事件。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端覆盖',
    desc: '支持手机版、网页版、APP多平台无缝切换，永久域名稳定访问，随时随地畅快吃瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全访问',
    desc: '多备用域名保障访问畅通，SSL加密传输保护隐私，让你安心浏览无后顾之忧。',
  },
  {
    icon: 'ri-group-line',
    title: '海量内容',
    desc: '涵盖娱乐八卦、影视综艺、网红动态、音乐现场等全方位内容，一站式满足你的吃瓜需求。',
  },
];

export const topicsList = [
  { name: '顶流恋情', heat: '1287万', color: 'primary' },
  { name: '热播剧大结局', heat: '1056万', color: 'accent' },
  { name: '综艺翻车', heat: '943万', color: 'primary' },
  { name: '演唱会事故', heat: '876万', color: 'accent' },
  { name: '代言解约', heat: '798万', color: 'primary' },
  { name: '网红带货', heat: '721万', color: 'accent' },
  { name: '男团解散', heat: '654万', color: 'primary' },
  { name: '选秀黑幕', heat: '589万', color: 'accent' },
  { name: '明星塌房', heat: '532万', color: 'primary' },
  { name: '剧组路透', heat: '478万', color: 'accent' },
];

export const faqItems = [
  {
    q: '51吃瓜网是什么平台？',
    a: '51吃瓜网是国内领先的娱乐资讯聚合平台，汇集全网最新最热的娱乐八卦、影视综艺、网红动态、音乐现场等全方位吃瓜内容，为用户提供一站式吃瓜体验。我们通过多源实时采集与智能推荐，确保用户能第一时间获取最新热点资讯。',
  },
  {
    q: '如何下载51吃瓜APP？',
    a: '您可以通过本页面顶部和底部的APP下载入口，选择安卓版或iOS版进行下载安装。目前支持手机版网页直接访问和独立APP两种方式，推荐下载APP获得更流畅的浏览体验和实时推送通知。',
  },
  {
    q: '51吃瓜网的永久域名是什么？',
    a: '本站为51吃瓜网官方认证域名，请您牢记并收藏本页面。如遇域名变动，我们会通过官方渠道及时公布最新入口地址。建议同时关注我们的社交媒体账号获取第一手域名更新通知。',
  },
  {
    q: '手机版和网页版有什么区别？',
    a: '手机版和网页版内容完全同步，核心差异在于使用体验：APP支持离线缓存、夜间模式、个性化推荐和实时推送；网页版无需安装，浏览器直接访问即可。两者均使用相同的永久域名。',
  },
  {
    q: '平台上的内容是否免费？',
    a: '51吃瓜网所有内容完全免费开放，用户无需注册或付费即可浏览全部资讯、查看热搜榜单和参与话题讨论。我们致力于打造开放、免费的娱乐资讯共享平台。',
  },
  {
    q: '如何确保访问安全和隐私保护？',
    a: '我们采用SSL加密传输技术保护用户数据安全，所有访问均通过HTTPS协议加密。平台不强制要求用户注册，浏览记录不关联个人身份信息。同时我们设有多条备用访问线路，确保服务稳定性。',
  },
];

export const mediaItems = [
  {
    title: '独家揭秘：某顶流恋情时间线全梳理',
    duration: '15:32',
    views: '289万',
    category: '深度扒皮',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20setup%20with%20warm%20red%20and%20gold%20lighting%2C%20professional%20broadcast%20microphone%20and%20headphones%20on%20a%20dark%20wooden%20desk%2C%20abstract%20geometric%20background%20with%20soft%20bokeh%20lights%2C%20editorial%20photography%20style%2C%20clean%20and%20modern%20composition&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    title: '综艺录制现场冲突完整还原',
    duration: '12:08',
    views: '216万',
    category: '现场还原',
    image: 'https://readdy.ai/api/search-image?query=Modern%20television%20studio%20with%20dramatic%20red%20curtains%20and%20warm%20stage%20lighting%2C%20empty%20talk%20show%20set%20with%20two%20armchairs%2C%20atmospheric%20smoke%20effect%2C%20professional%20cinematic%20photography%2C%20deep%20shadows%20and%20golden%20accents&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    title: '网红直播间翻车名场面合集',
    duration: '08:45',
    views: '198万',
    category: '搞笑合集',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20livestream%20studio%20with%20ring%20light%20and%20product%20display%20table%2C%20warm%20ambient%20lighting%2C%20sleek%20modern%20smartphone%20on%20tripod%2C%20abstract%20golden%20and%20crimson%20background%20elements%2C%20professional%20product%20photography%20style&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
  {
    title: '男团解散内幕知情人爆料',
    duration: '18:20',
    views: '167万',
    category: '独家爆料',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20concert%20stage%20with%20colorful%20spotlights%20and%20fog%20machine%20effects%2C%20empty%20stage%20with%20microphone%20stand%2C%20warm%20golden%20and%20red%20lighting%2C%20cinematic%20atmosphere%2C%20professional%20event%20photography%20style%2C%20theatrical%20mood&width=800&height=450&seq=media-card-04&orientation=landscape',
  },
];

export const indexItems = [
  {
    title: '深度扒皮专区',
    desc: '事件时间线、人物关系图谱、多方视角还原，吃瓜就要吃透彻。',
    count: 128,
    icon: 'ri-search-eye-line',
  },
  {
    title: '实时热搜追踪',
    desc: '分钟级更新的热搜榜单，热门事件不再错过。',
    count: 256,
    icon: 'ri-fire-line',
  },
  {
    title: '综艺录制路透',
    desc: '现场观众一手爆料，录制未播内容抢先看。',
    count: 89,
    icon: 'ri-camera-lens-line',
  },
  {
    title: '明星动态速递',
    desc: '明星行程、街拍路透、社交媒体动态实时监控。',
    count: 312,
    icon: 'ri-flight-takeoff-line',
  },
  {
    title: '影视剧评讨论',
    desc: '热播剧集剧情讨论、演技点评、结局预测。',
    count: 175,
    icon: 'ri-movie-2-line',
  },
  {
    title: '网红圈八卦站',
    desc: '网红互撕、带货翻车、人设崩塌全记录。',
    count: 203,
    icon: 'ri-live-line',
  },
  {
    title: '音乐现场直击',
    desc: '演唱会事故、音乐节名场面、歌手最新动态。',
    count: 94,
    icon: 'ri-music-line',
  },
];

export const carouselItems = [
  {
    title: '独家揭秘：某顶流恋情时间线全梳理',
    desc: '从第一次同框到工作室回应，带你完整回顾这场娱乐圈年度大瓜的全过程。多方知情人爆料、粉丝前线追踪、品牌方紧急应对，每一个细节都值得细品。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20scene%20with%20dramatic%20warm%20lighting%2C%20blurred%20crowd%20background%20with%20camera%20flashes%2C%20luxurious%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20mysterious%20and%20glamorous%20mood&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '综艺录制现场嘉宾互撕完整还原',
    desc: '某热门综艺最新一期录制现场突发状况，两位常驻嘉宾因游戏环节产生激烈争执，节目组紧急叫停录制。现场观众还原全过程，网友分成两派激烈讨论。',
    tag: '现场直击',
    image: 'https://readdy.ai/api/search-image?query=Television%20talk%20show%20set%20with%20two%20empty%20armchairs%20facing%20each%20other%2C%20dramatic%20split%20lighting%20in%20warm%20gold%20and%20deep%20red%2C%20atmospheric%20stage%20with%20curtains%2C%20cinematic%20wide%20shot%2C%20professional%20studio%20photography&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '网红带货翻车名场面年度合集',
    desc: '盘点2024-2025年度最令人啼笑皆非的直播带货事故，从产品质量问题到主播口误，从价格争议到发货延迟，每一个都是教科书级别的翻车案例。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20product%20photography%20studio%20with%20softbox%20lighting%2C%20various%20beauty%20products%20arranged%20on%20marble%20surface%2C%20warm%20golden%20and%20soft%20pink%20color%20scheme%2C%20professional%20commercial%20photography%2C%20clean%20and%20elegant%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '男团解散风波：成员各自发展去向',
    desc: '某当红男团突然宣布解散消息震惊粉丝圈，成员个人社交媒体动态暗藏玄机。我们整理了每个成员的最新动向和签约传闻，以及业内人士对解散原因的分析。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20empty%20concert%20stage%20with%20seven%20microphone%20stands%20in%20a%20row%2C%20spotlights%20creating%20dramatic%20shadows%2C%20dark%20atmosphere%20with%20warm%20golden%20accent%20lighting%2C%20cinematic%20photography%2C%20emotional%20and%20theatrical%20mood&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '演唱会突发状况：歌手敬业表现获赞',
    desc: '某实力派歌手在个人巡回演唱会上遭遇舞台设备故障，面对突发情况临危不乱，清唱完成整首歌曲，现场观众自发打开手机闪光灯应援，场面感人至深。',
    tag: '感动瞬间',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stadium%20with%20thousands%20of%20phone%20flashlights%20creating%20a%20sea%20of%20stars%2C%20dark%20atmosphere%20with%20warm%20golden%20pinpoints%20of%20light%2C%20epic%20scale%2C%20emotional%20and%20powerful%20mood%2C%20cinematic%20wide%20angle%20photography&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '代言解约潮：品牌与明星的关系变局',
    desc: '近期多位明星接连遭遇品牌解约，背后涉及个人形象风险、合约条款争议以及品牌策略调整等多重因素。深度解析明星代言市场的最新变化趋势。',
    tag: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20long%20conference%20table%2C%20dramatic%20lighting%20from%20large%20windows%2C%20warm%20golden%20sunset%20light%20casting%20long%20shadows%2C%20professional%20business%20photography%2C%20clean%20modern%20office%20interior%2C%20atmospheric%20mood&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export const cardsItems = [
  {
    title: '某小花与经纪公司合约纠纷新进展',
    desc: '继上月传出解约传闻后，双方律师团队已正式介入谈判。据知情人士透露，核心争议点在于演艺经纪分成比例和自主选择剧本的权利。业内人士分析认为，此案可能成为行业合同范本修订的催化剂。',
    date: '2026-07-29',
    category: '娱乐法眼',
    image: 'https://readdy.ai/api/search-image?query=Legal%20office%20with%20contract%20documents%20and%20fountain%20pen%20on%20dark%20wooden%20desk%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20professional%20and%20serious%20atmosphere%2C%20editorial%20photography%20style%2C%20rich%20brown%20and%20gold%20tones&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    title: '热门IP改编新剧阵容官宣引期待',
    desc: '改编自年度畅销小说的古装剧今日正式公布主演阵容，一线演员领衔搭配新锐实力派，制作团队为业内顶级配置。原著粉和路人观众对选角评价两极分化，话题热度持续攀升。',
    date: '2026-07-28',
    category: '影视速递',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20drama%20set%20with%20flowing%20red%20silk%20fabric%20and%20ornate%20golden%20accessories%2C%20soft%20dramatic%20lighting%2C%20elegant%20and%20artistic%20composition%2C%20cinematic%20photography%2C%20classical%20Chinese%20aesthetic&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    title: '音乐节阵容泄露引发主办方紧急辟谣',
    desc: '一份疑似某大型音乐节的演出阵容名单在社交平台疯传，包含多位国际知名艺人。主办方火速发布声明称名单不实，但同时暗示实际阵容"更有惊喜"，吊足乐迷胃口。',
    date: '2026-07-27',
    category: '音乐前线',
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20main%20stage%20at%20sunset%2C%20large%20speaker%20arrays%20and%20lighting%20rigs%2C%20warm%20golden%20hour%20sky%2C%20empty%20festival%20grounds%20with%20atmospheric%20dust%20particles%2C%20cinematic%20wide%20shot%2C%20epic%20scale&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    title: '选秀节目投票机制再遭质疑',
    desc: '某正在热播的选秀节目因投票规则频繁改动引发选手粉丝不满，多个粉丝后援会联合发布声明要求节目组公开投票数据。此前该节目已因类似问题被主管部门约谈。',
    date: '2026-07-26',
    category: '综艺观察',
    image: 'https://readdy.ai/api/search-image?query=Television%20talent%20show%20stage%20with%20dramatic%20spotlight%20and%20empty%20center%20position%2C%20dark%20background%20with%20colorful%20LED%20light%20effects%2C%20professional%20studio%20photography%2C%20atmospheric%20and%20dramatic%20mood&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    title: '某老牌歌手复出演唱会一票难求',
    desc: '宣布复出的实力派歌手首场演唱会门票开售后30秒售罄，黄牛票价格炒至原价五倍以上。主办方紧急宣布加开两场，以满足歌迷需求。歌手的复出首秀备受瞩目。',
    date: '2026-07-25',
    category: '演出现场',
    image: 'https://readdy.ai/api/search-image?query=Grand%20concert%20hall%20interior%20with%20red%20velvet%20seats%20and%20ornate%20golden%20decorations%2C%20empty%20stage%20with%20grand%20piano%2C%20warm%20elegant%20lighting%2C%20classical%20theater%20atmosphere%2C%20luxurious%20and%20romantic%20mood&width=600&height=400&seq=cards-05&orientation=landscape',
  },
  {
    title: '短视频平台大V互撕事件持续发酵',
    desc: '两位千万粉丝级别的短视频创作者因内容抄袭争议在评论区公开互怼，随后各自发布长视频"摆证据"。事件引发平台其他创作者站队，相关话题连续三天霸占热搜。',
    date: '2026-07-24',
    category: '网红风云',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20social%20media%20interface%20on%20minimalist%20desk%2C%20dramatic%20red%20and%20blue%20split%20lighting%2C%20professional%20tech%20product%20photography%2C%20clean%20composition%2C%20atmospheric%20mood%2C%20digital%20conflict%20theme&width=600&height=400&seq=cards-06&orientation=landscape',
  },
];

export const commentsList = [
  {
    name: '吃瓜不嫌事大',
    content: '这个时间线整理得太清楚了！我之前零零散散看到的消息终于串起来了。期待后续更新，已收藏。',
    time: '2小时前',
    likes: 1286,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20silhouette%20with%20warm%20peach%20and%20golden%20gradient%2C%20modern%20geometric%20style%2C%20clean%20simple%20design%2C%20soft%20lighting%2C%20artistic%20profile&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '娱乐圈观察员',
    content: '作为在圈内工作的人，我只能说这里面有些料比外面传的靠谱多了。小编是有真料的人，持续关注中。',
    time: '5小时前',
    likes: 967,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20silhouette%20with%20warm%20coral%20and%20rose%20gradient%2C%20modern%20geometric%20style%2C%20clean%20simple%20design%2C%20soft%20lighting%2C%20artistic%20profile&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '路人甲路过',
    content: '本来只是随便逛逛，结果一看就停不下来了。这个网站内容太全了，比在社交平台到处翻方便多了。',
    time: '8小时前',
    likes: 534,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20silhouette%20with%20warm%20amber%20and%20gold%20gradient%2C%20modern%20geometric%20style%2C%20clean%20simple%20design%2C%20soft%20lighting%2C%20artistic%20profile&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    name: '深夜吃瓜人',
    content: '大半夜刷到这个网站简直停不下来！整理得很用心，每个事件的来龙去脉都很清楚。已推荐给朋友。',
    time: '12小时前',
    likes: 428,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20silhouette%20with%20warm%20copper%20and%20bronze%20gradient%2C%20modern%20geometric%20style%2C%20clean%20simple%20design%2C%20soft%20lighting%2C%20artistic%20profile&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
];

export const updatesList = [
  {
    date: '2026-07-30',
    title: '系统升级通知',
    content: '平台已完成服务器扩容和CDN加速部署，访问速度提升40%，移动端加载更流畅。新增夜间模式，夜间吃瓜更护眼。',
    type: 'system',
  },
  {
    date: '2026-07-28',
    title: '新增深度专题功能',
    content: '「深度扒皮」专题板块正式上线，针对重大事件提供完整时间线、人物关系图谱和多角度分析文章。首期专题聚焦近期顶流恋情事件。',
    type: 'feature',
  },
  {
    date: '2026-07-25',
    title: 'APP版本更新v3.2.0',
    content: '安卓和iOS双端同步更新：优化推送通知逻辑，减少打扰频率；新增自定义话题订阅功能；修复部分机型闪退问题。',
    type: 'update',
  },
  {
    date: '2026-07-22',
    title: '域名安全加固公告',
    content: '针对近期恶意仿冒站点，我们已启用更严格的域名保护措施。请认准本站为唯一官方认证域名，谨防钓鱼网站。',
    type: 'system',
  },
  {
    date: '2026-07-18',
    title: '内容团队扩充',
    content: '编辑团队新增10名资深娱乐记者和3名数据分析师，内容更新频率提升至每小时一次，确保用户获取最新资讯。',
    type: 'team',
  },
  {
    date: '2026-07-15',
    title: '用户反馈通道上线',
    content: '开通用户投稿和内容反馈通道，欢迎广大吃瓜群众提供线索和爆料。优质投稿将获得首页推荐位展示机会。',
    type: 'feature',
  },
  {
    date: '2026-07-10',
    title: '平台全新改版',
    content: '首页全面升级，新增热度榜单、话题标签、焦点专题等多个实用模块。视觉风格焕新，阅读体验全面提升。',
    type: 'update',
  },
];